<template>
  <div class="pageContent">
    <div class="table_box">
      <div class="activity_card">
        <div class="card_left">
          <img
            v-if="tableData.url"
            style="width: 100%;height: 100%"
            :src="tableData.url"
          />
          <img
            v-else
            style="width: 100%;height: 100%"
            src="http://zht.58zltc.com/public/uploads/20210619174140e22cb3109.jpg"
          />
        </div>
        <div class="card_right" style="height: 89px">
          <span style="font-size: 18px;font-weight: 560">{{
            tableData.name
          }}</span>
          <span>创建时间: {{ tableData.create_time | dataFormat }}</span>
          <div>
            <span>{{ card_types[tableData.card_type] }}</span>
            <span
              v-text="
                tableData.card_type == 1
                  ? tableData.card_amount
                  : tableData.card_type == 2
                  ? tableData.card_num
                  : tableData.show_card_duration_info
              "
            ></span>
          </div>
        </div>
      </div>
      <el-card style="width: 100%;margin-top: 20px;" type="border-card">
        <div slot="header" class="clearfix">
          <span>活动详情</span>
        </div>
        <div class="card_detil_top">
          <div class="card_detil_item">
            <span>创建时间:</span>
            <span>{{ tableData.create_time | dataFormat }}</span>
          </div>
          <div class="card_detil_item">
            <span>活动介绍:</span>
            <span v-html="tableData.detail"></span>
          </div>
        </div>
        <el-divider></el-divider>
        <div class="card_detil_item">
          <span>使用规则</span>
          <template>
            <div style="margin:10px 0;" v-if="tableData.card_type == 1 || tableData.card_type == 2">
              <span>此卡有效期: </span>
              <span
                >{{ tableData.platform_card_data.day || 0 }}天{{
                  tableData.platform_card_data.hour || 0
                }}小时{{ tableData.platform_card_data.minute || 0 }}分钟{{
                  tableData.platform_card_data.second || 0
                }}秒</span
              >
            </div>
            <span
              class="card_detil_title"
              v-text="
                roles.every_reduction == 1
                  ? '（每满减）'
                  : roles.unified_offer == 1
                  ? '（统一优惠）'
                  : roles.cate_offer == 1
                  ? '（类别优惠）'
                  : roles.full_reduction == 1
                  ? '（区间满减）'
                  : roles.goods_offer == 1
                  ? '（油品优惠）'
                  : ''
              "
            ></span>

            <div v-if="roles.unified_offer == 1">
              {{ roles.unified_offer_value.dis_str }}
            </div>
            <div v-if="roles.cate_offer == 1 || roles.goods_offer == 1">
              <div
                v-for="(item, index) in roles.cate_offer == 1
                  ? roles.cate_offer_value
                  : roles.goods_offer == 1
                  ? roles.goods_offer_value
                  : []"
                :key="index"
              >
                <span v-if="item.name">{{ item.name }}: </span>
                <div>
                  {{ item.dis_str }}
                </div>
              </div>
            </div>
            <div v-if="roles.full_reduction == 1 || roles.every_reduction == 1">
              <div
                v-for="(item, index1) in roles.full_reduction == 1
                  ? roles.full_discount
                  : roles.every_reduction == 1
                  ? roles.every_discount
                  : []"
                :key="index1"
              >
                <div
                  class="card_detil_title"
                  v-text="
                    roles.full_reduction == 1
                      ? `消费满${item.num}元`
                      : roles.every_reduction == 1
                      ? `每减金额${item.num}元`
                      : ''
                  "
                ></div>

                <div v-if="item.unified_offer == 1">
                  {{ item.unified_offer_value.dis_str }}
                </div>

                <div v-if="item.cate_offer == 1 || item.goods_offer == 1">
                  <div
                    v-for="(items, index2) in item.cate_offer == 1
                      ? item.cate_offer_value
                      : item.goods_offer == 1
                      ? item.goods_offer_value
                      : []"
                    :key="index2"
                  >
                    <span v-if="items.name">{{ items.name }}: </span>
                    <div>
                      {{ items.dis_str }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </el-card>
      <div style="display: flex;justify-content: center">
        <el-button
          size="medium"
          style="width:100px;height:40px;margin-top: 50px;font-size: 22px"
          type="primary"
          @click="platformcard(tableData)"
          v-text="status === 2 ? '设置' : '报名'"
          >报名
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { platformcard_card_detail, platformcard_join_card } from "@/api/platform_card";
import { getOilSortList, goodsList } from "@/api/vip";
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["app_id"])
  },
  data() {
    return {
      card_types: ["", "面值: ", "次数: ", "时效: "],
      items: [
        { type: "info", name: "未参与" },
        { type: "warning", name: "审核中" },
        { type: "success", name: "审核通过" },
        { type: "danger", name: "审核拒绝" }
      ],
      tableData: {},
      tableRowClassName: "22",
      page: 1,
      total_num: 0,
      value: true,
      status: 0,
      roles: {},
      goods: [],
      options: []
    };
  },
  mounted() {
    this.get_tableData();
  },
  methods: {
    async get_tableData() {
      try {
        const res = await platformcard_card_detail({
          app_id: this.app_id,
          id: this.$route.query.id
        });
        this.tableData = res.data;
        let platform_card_data = res.data.platform_card_data;
        this.roles = res.data.platform_card_data;
        this.status = platform_card_data.status;
        const goods = await goodsList({
          app_id: this.app_id
        });
        const options = await getOilSortList(this.token, this.app_id);
        this.goods = goods.data;
        this.options = options.data;
        console.log("goods", options);
        if (this.tableData.card_type == 3) {
          this.tableData.show_card_duration_info =
            this.tableData.card_duration_info.day +
            "天" +
            this.tableData.card_duration_info.hour +
            "时" +
            this.tableData.card_duration_info.minute +
            "分" +
            this.tableData.card_duration_info.second +
            "秒";
        }
        if (platform_card_data.goods_offer_value) {
          platform_card_data.goods_offer_value.forEach(item => {
            item.name = this.goods.find(o => o.id === Number(item.goods)).name;
          });
        }
        if (platform_card_data.cate_offer_value) {
          platform_card_data.cate_offer_value.forEach(item => {
            item.name = this.options.find(o => o.id === Number(item.cate)).name;
          });
        }

        if (platform_card_data.full_reduction == 1) {
          let nums = Object.keys(platform_card_data.full_discount);
          let full_discount = Object.values(platform_card_data.full_discount);
          full_discount.forEach((item, i) => {
            item.num = nums[i];
            console.log(item, i);
          });
          this.roles.full_discount = full_discount;
        }
        if (platform_card_data.every_reduction == 1) {
          let num = Object.keys(platform_card_data.every_discount);
          let every_discount = Object.values(platform_card_data.every_discount);
          every_discount.forEach((item, i) => {
            item.num = num[i];
            console.log(item, i);
          });
          console.log(every_discount);
          this.roles.every_discount = every_discount;
        }
      } catch (e) {
        console.log(e);
      }
    },
    platformcard(row) {
      if (row.platform_card_data.status == 2) {
        this.$router.push({
          path: "/apply/newVip/13/card/activityCard/set_card",
          query: {
            id: this.tableData.id
          }
        });
      } else {
        platformcard_join_card({
          app_id: this.app_id,
          id: this.$route.query.id
        }).then(res => {
          if (res.code == 200) {
            this.$message.success("报名成功,请等待管理员审核");
            // this.get_tableData();
            this.$router.back(-1);
          } else {
            this.$message(res.msg);
          }
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "./card.scss";

.pageContent {
  border: 20px solid #f1f2f6;
  padding: 0 20px 10px 20px;
  height: 100%;
  overflow: auto;

  .options {
    line-height: 79px;
  }

  .table_box {
    margin-bottom: 20px;
  }

  .form_input {
    width: 240px;
  }
}
.clearfix {
  font-size: 18px;
}
</style>
